"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIAcceptMatchStatus = void 0;
var APIAcceptMatchStatus;
(function (APIAcceptMatchStatus) {
    APIAcceptMatchStatus["Accepted"] = "accepted";
    APIAcceptMatchStatus["Declined"] = "declined";
    APIAcceptMatchStatus["PartiallyAccepted"] = "partially_accepted";
})(APIAcceptMatchStatus = exports.APIAcceptMatchStatus || (exports.APIAcceptMatchStatus = {}));
